
const Filter = () => {
	const toggles = Array.from(document.querySelectorAll('.filter .md-toggle'));
	const selects = Array.from(document.querySelectorAll('.filter select'));

	function closeAllPopUps() {
		toggles.forEach(item => {
			item.parentNode.parentNode.classList.remove('is-open');
		});
	}

	// toggle the current filter and close all others
	toggles.forEach(item => {
		item.addEventListener('click', (e) => {
			e.stopPropagation();
			var isOpen = item.parentNode.parentNode.classList.contains('is-open');
			closeAllPopUps();
			if(!isOpen) {
				item.parentNode.parentNode.classList.add('is-open');
			}
		});
	});

	// is a fitler is open, close it on a document click
	document.addEventListener('click', (e) => {
		var tagName = e.target.nodeName.toLowerCase();
		if(tagName != 'select' && tagName != 'option') {
			closeAllPopUps();
		}
	});


	// Return an array of the selected opion values
	// select is an HTML select element
	// see https://stackoverflow.com/questions/5866169/how-to-get-all-selected-values-of-a-multiple-select-box/5866331
	function getSelectValues(select) {
		var result = [];
		var options = select && select.options;
		var opt;

		for (var i=0, iLen=options.length; i<iLen; i++) {
			opt = options[i];

			if (opt.selected) {
				result.push(opt.value || opt.text);
			}
		}
		return result;
	}


	function getSelectText(select) {
		var result = [];
		var options = select && select.options;
		var opt;

		for (var i=0, iLen=options.length; i<iLen; i++) {
			opt = options[i];

			if (opt.selected) {
				result.push(opt.innerHTML);
			}
		}
		return result;
	}

	selects.forEach(select => {
		let values = getSelectValues(select);
		var currentlyHasAll = values.indexOf('0') > -1;
		
		var filterList = select.parentNode.parentNode.querySelector('.filter-list');
		filterList.innerHTML = '<li class="checked">' + getSelectText(select).join('</li><li class="checked">') + '</li>';

		select.addEventListener('change', (event) => {

			// handle option "all"
			let hadAll = currentlyHasAll;
			let values = getSelectValues(select);
			currentlyHasAll = values.indexOf('0') > -1;

			if(!hadAll && currentlyHasAll) {
				// remove all not 'all'
				Array.from(select.querySelectorAll('option')).forEach(item => item.selected = false);
				select.querySelector('option[value="0"]').selected = 'selected';
			}
			if(hadAll && currentlyHasAll && values.length>1) {
				// remove 'all'
				select.querySelector('option[value="0"]').selected = false;
			}

			// update filter list
			filterList.innerHTML = '<li class="checked">' + getSelectText(select).join('</li><li class="checked">') + '</li>';
		});
	});
};

export default Filter;
